import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import createLogger from 'redux-logger'
import createSagaMiddleware from 'redux-saga'
import errorHandler from 'helpers/errorHandler'
import Application from 'components/Application'
import app from 'reducers'
import rootSaga from 'sagas'
import createHandlers from 'helpers/createHandlers'

const sagaMiddleware = createSagaMiddleware()
const logger = createLogger(
  Object.assign(
  {},
  { collapsed: true }
  )
)

let store = createStore(
  app,
  applyMiddleware(sagaMiddleware, errorHandler(), logger)
)
sagaMiddleware.run(rootSaga, store.dispatch)

if (typeof Cypress !== 'undefined') { Cypress.store = store }

// create handlers that dispatch actions so we can control
// the app during exports
global.handlers = createHandlers(store)

const App = _ => (
  <Provider store={store}>
    <Application />
  </Provider>
)

render(<App />, document.getElementById('app'))



// WEBPACK FOOTER //
// ./src/index.jsx